'use client';
import React from 'react';
import { useConnatixLivestream } from '@benzinga/livestream-hooks';
import Hooks from '@benzinga/hooks';
import { ConnatixVideoPlayer, ConnatixPlayerParams } from './index';

export const ConnatixLivePlayer: React.FC<ConnatixPlayerParams> = props => {
  const { assembleLivestream, livestreamData } = useConnatixLivestream();
  const [videoPlayerClass, setVideoPlayerClass] = React.useState('video-player-wrapper');

  Hooks.useEffectDidMount(() => {
    assembleLivestream().then(() => {
      if (livestreamData) {
        setVideoPlayerClass('video-player-wrapper livestream');
      }
    });
  });

  return (
    <div className={videoPlayerClass}>
      {livestreamData ? (
        <ConnatixVideoPlayer {...livestreamData} key="livestream" />
      ) : (
        <ConnatixVideoPlayer {...props} />
      )}
    </div>
  );
};
